// Detect user's country/location for better gift recommendations

export const detectUserLocation = async () => {
  try {
    // Try to get location from IP (free service)
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    return {
      country: data.country_name || 'United States',
      countryCode: data.country_code || 'US',
      currency: data.currency || 'USD',
      timezone: data.timezone || 'America/New_York'
    };
  } catch (error) {
    console.warn('Could not detect location, using defaults:', error);
    // Default to US if detection fails
    return {
      country: 'United States',
      countryCode: 'US',
      currency: 'USD',
      timezone: 'America/New_York'
    };
  }
};
